module.exports = __webpack_public_path__ + "assets/images/BSD1.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/BSD1.png
// module id = 1314
// module chunks = 1